import { getConfig } from './config';

import type { LocalisationConfigEntry, LocalisationConfigValue } from '../types';

export default function getLocalisationConfig(key: LocalisationConfigEntry) {
  return getConfig()[key] as LocalisationConfigValue;
}
